var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FECDCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0019 23.8347V28.5014M28.0019 33.168H28.0135M26.0069 17.838L16.1252 34.3347C15.9215 34.6875 15.8136 35.0876 15.8125 35.495C15.8114 35.9024 15.9169 36.303 16.1187 36.657C16.3204 37.011 16.6114 37.3059 16.9625 37.5125C17.3137 37.7192 17.7128 37.8302 18.1202 37.8347H37.8835C38.2909 37.8302 38.69 37.7192 39.0412 37.5125C39.3923 37.3059 39.6833 37.011 39.885 36.657C40.0868 36.303 40.1923 35.9024 40.1912 35.495C40.1901 35.0876 40.0823 34.6875 39.8785 34.3347L29.9969 17.838C29.7889 17.4952 29.496 17.2117 29.1466 17.0149C28.7971 16.8182 28.4029 16.7148 28.0019 16.7148C27.6008 16.7148 27.2066 16.8182 26.8571 17.0149C26.5077 17.2117 26.2148 17.4952 26.0069 17.838Z",
    stroke: "#B42318",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.30cec15e7dc93f16331ed258c62543c3.svg";
export { ForwardRef as ReactComponent };